import React from 'react'
import {
  HashRouter,
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import AdminLogin from '@/pages/login'

import ClientRouters from './client'
import AdminRouters from './admin'
// import './style.less'

class Routers extends React.Component {
  render () {
    const location = this.props.location

    return (
      <div>
        <HashRouter>
          <Router>
            <Switch>
              <Route path="/login">
                <AdminLogin />
              </Route>
              <Route path="/admin">
                <AdminRouters />
              </Route>
              <Route path="/">
                <ClientRouters />
              </Route>
            </Switch>
          </Router>
        </HashRouter>
      </div>
    )
  }
}

export default Routers